import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { Editor } from 'libs/editor';
import { Username } from 'apps/components/shared';
import { Date } from 'apps/components/date';
import { Comments } from 'apps/comments/main';
import { OpSection } from 'apps/repository/contributionPage/views/opSection';

import {
  SubPageWrapper,
  SubPageTitle,
  SubPageInfo,
  SubPageDescription,
  Divider,
} from 'legacyComponents/styled/lib';

@withNamespaces()
@observer
export class ContributionPageContent extends React.Component {
  render() {
    const { contribution, t } = this.props;
    const {
      operations,
      title,
      creatorProfile,
      dateCreated,
      description,
    } = contribution;
    const contributorUsername = creatorProfile.username;

    const addOps = operations.filter(op => op.opType === 'ADD');
    const updateOps = operations.filter(op => op.opType === 'UPDATE');
    const renameOps = operations.filter(op => op.opType === 'RENAME');
    const removeOps = operations.filter(op => op.opType === 'REMOVE');

    const sections = {
      Added: addOps,
      Updated: updateOps,
      Renamed: renameOps,
      Removed: removeOps,
    };

    // FIXME
    const store = new EditorStore({
      initialValue: html.deserialize(
        description || '<p><em>No description provided.</em></p>',
      ),
      formatting: 'basic',
    });

    return (
      <SubPageWrapper width='72%'>
        <SubPageTitle>{title}</SubPageTitle>
        <SubPageInfo>
          <Trans>
            Contributed by{' '}
            <Username name='profile' params={{ profile: contributorUsername }}>
              {{ contributorUsername }}
            </Username>
          </Trans>{' '}
          | <Date value={dateCreated} />
        </SubPageInfo>
        {description !== '<p></p>' && (
          <SubPageDescription>
            <Editor store={store} />
          </SubPageDescription>
        )}
        {description !== '<p></p>' && (
          <SubPageDescription>
            <i>
              <Trans>No description provided</Trans>.
            </i>
          </SubPageDescription>
        )}
        {Object.entries(sections).map(([section, ops]) =>
          ops.length === 0 ? null : (
            <OpSection
              key={section}
              title={t(`${section} Files`)}
              count={ops.length}
              ops={ops}
              contribution={contribution}
            />
          ),
        )}
        <Divider width='100%' margin='40px auto 10px auto' />
        <Comments content={contribution} contentType='Contribution' />
      </SubPageWrapper>
    );
  }
}

ContributionPageContent.propTypes = {
  contribution: PropTypes.object,
  t: PropTypes.func,
};
